var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "json-group-item" }, [_vm.isAutoEndTime || _vm.isPlayAgain ? _c('optional-group-item', { attrs: { "category": _vm.category, "template-config": _vm.templateConfig }, on: { "update": _vm.updateJsonConfig, "add-validator": function addValidator(validate) {
        _vm.addValidator({
          name: 'optional-group-item',
          validate: validate
        });
      } } }) : _vm.isMwConfig && _vm.mwConfig ? _c('mw-config-switch', { attrs: { "switch-name": _vm.category.prefix } }) : _vm.isI18n && _vm.i18n ? _c('language-packs', { attrs: { "languages": _vm.i18n, "category": _vm.category, "template-config": _vm.templateConfig }, on: { "update": _vm.updateJsonConfig, "add-validator": function addValidator(validate) {
        _vm.addValidator({
          name: 'language-packs',
          validate: validate
        });
      } } }) : _vm.isColorConfig && _vm.colorConfig ? _c('color-config', { attrs: { "category": _vm.category, "config": _vm.colorConfig }, on: { "update": _vm.updateJsonConfig, "add-validator": function addValidator(validate) {
        _vm.addValidator({
          name: 'color-config',
          validate: validate
        });
      } } }) : [_vm.gameDifficulty === 'v2' || _vm.gameDifficulty === 'v1' ? _c('el-alert', { attrs: { "title": "不支持该模板的 gameConfig，请使用最新版配置", "type": "error", "closable": false } }) : _vm.gameDifficulty === 'v3' ? _c('game-difficulty', { attrs: { "category": _vm.category, "template-config": _vm.templateConfig } }) : _vm._e()]], 2);
};
var staticRenderFns = [];

export { render, staticRenderFns };